/* eslint-disable @typescript-eslint/no-explicit-any */
import { ApiKey, SaveApiKey } from 'model/apiKeys';
import { ApiKeyDto, SaveApiKeyDto } from './ApiKeysDtos';

/**
 * Convert API Key DTO to API Key Model
 * snake_case (API) to camelCase (domain model).
 *
 * `client_secret` is deliberately dropped here. It only exists in the create
 * and rotate responses and must not travel into the store; the thunks read it
 * straight off the raw DTO and hand it to the caller.
 */
export const convertToApiKey = (dto: ApiKeyDto): ApiKey => {
    const locationIds = Array.isArray(dto.marketplace_ids) ? dto.marketplace_ids : [];

    return {
        id: dto.id,
        uuid: dto.uuid,
        organizationId: dto.organization_id,
        name: dto.name,
        active: dto.active,
        scopes: Array.isArray(dto.scopes) ? dto.scopes : [],
        locationIds,
        // An empty allowlist grants the whole organization subtree. Made
        // explicit so no screen has to remember that rule.
        allLocations: locationIds.length === 0,
        clientId: dto.client_id ?? null,
        expiresAt: dto.expires_at ?? null,
        createdAt: dto.created_at,
        updatedAt: dto.updated_at
    };
};

/**
 * Convert API Key Model to SaveApiKeyDto
 * camelCase (domain model) to snake_case (API format).
 *
 * `allLocations` collapses back to an empty array, which is what the backend
 * reads as "every location in the organization".
 */
export const convertToSaveApiKeyDto = (apiKey: SaveApiKey): SaveApiKeyDto => {
    return {
        project: {
            name: apiKey.name,
            scopes: apiKey.scopes,
            marketplace_ids: apiKey.allLocations ? [] : apiKey.locationIds,
            expires_at: apiKey.expiresAt ?? null
        }
    };
};
